export default {
    "fr": {
        "metas": {
            "title": "{term} - {glossary} - ASA Links",
            "description": "Retrouvez la définition du terme douanier « {term} » sur Asalinks, représentant en douane enregistrée (RDE), certifiée Opérateur Économique Agréé (OEA) et habilitée à dédouaner tout type de marchandise"
        }
    },
    "en": {
        "metas": {
            "title": "{term} - {glossary} - ASA Links",
            "description": "Find the definition of the customs term « {term} » on Asalinks, registered customs representative (RDE), certified Authorised Economic Operator (AEO) and authorised to clear any type of goods"
        }
    }
}
